import { get, post } from 'lib/axiosDefaults';
import apiEndPoints, { headers } from 'configs/endPoints';
import axios from 'axios';

const GoogleDriveApi = {
	getAllFileFromContentLibByOwnerId: (fileId) => {
		axios
			.get(
				`${apiEndPoints.getAllFileFromContentLibByOwnerId}?fileId=${fileId}`,
				headers('accessToken')
			)
			.then((response) => {
				console.log('data',response.data.data)
				return response.data;
			})
			.catch((error) => {
				console.log(error);
			});
	}
};

export default GoogleDriveApi;
